import _curry1 from './internal/_curry1';

/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */
var negate = /*#__PURE__*/_curry1(function negate(n) {
  return -n;
});
export default negate;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/negate.js
// module id = 2162
// module chunks = 1